/*eslint-disable*/
import React from "react";

// reactstrap components
import {
    Card,
    CardBody,
    CardImg,
    CardTitle,
    Row,
    Col,
} from "reactstrap";

// core components
import CustomCarousel from "../../CustomCarousel"

function EventImageRight({ caption, description, pictures }) {

    const carouselItems = pictures.map((picture) => {
        return (
            {
                src: picture,
                altText: description,
                caption: caption,
            }
        )
    })

    return (
        <>
            <div className="space-top" />
            <Row>
                <Col className="mr-auto" md="4" >
                    <Card className="card-plain">
                        <CardBody style={{ marginTop: 0 }}>
                            <CardTitle tag="h3">
                                {caption && caption}
                            </CardTitle>
                            <p className="card-description">
                                {description && description}
                            </p>
                        </CardBody>
                    </Card>
                </Col>
                <Col className="ml-auto" md="8">
                    <CardImg top tag="div">
                        <Card
                            className="card-raised page-carousel section-dark"
                            style={{ textAlign: "center" }}
                        >
                            <CustomCarousel style={{ maxHeight: "100vh", width: "auto" }} carouselItems={carouselItems} />
                        </Card>
                    </CardImg>
                </Col>
            </Row>
            <br />
            <hr />
            <br />
        </>
    );
}

export default EventImageRight;
